import React from 'react';
import { ScrollTextIcon, TwitterIcon, LinkedinIcon, GithubIcon } from 'lucide-react';
export const Footer = () => {
  return <footer id="contact" className="bg-burgundy-950 pt-16 pb-8 border-t-4 border-double border-gold-800" data-id="element-55">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-56">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-57">
          <div className="md:col-span-2" data-id="element-58">
            <a href="#" className="flex items-center gap-3 mb-6" data-id="element-59">
              <ScrollTextIcon className="w-8 h-8 text-gold-600" data-id="element-60" />
              <span className="font-display text-3xl font-bold text-gold-600 tracking-wider" data-id="element-61">
                Mythicplay
              </span>
            </a>
            <p className="text-parchment-300 max-w-md mb-6 leading-relaxed" data-id="element-62">
              The premier content syndication network connecting fantasy and
              entertainment creators with devoted audiences across realms.
            </p>
            <div className="flex gap-4" data-id="element-63">
              <a href="#" className="w-10 h-10 rounded-full border border-gold-700/50 flex items-center justify-center text-gold-600 hover:bg-gold-600/10 hover:text-gold-400 transition-all" data-id="element-64">
                <TwitterIcon className="w-4 h-4" data-id="element-65" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-gold-700/50 flex items-center justify-center text-gold-600 hover:bg-gold-600/10 hover:text-gold-400 transition-all" data-id="element-66">
                <LinkedinIcon className="w-4 h-4" data-id="element-67" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-gold-700/50 flex items-center justify-center text-gold-600 hover:bg-gold-600/10 hover:text-gold-400 transition-all" data-id="element-68">
                <GithubIcon className="w-4 h-4" data-id="element-69" />
              </a>
            </div>
          </div>

          <div data-id="element-70">
            <h4 className="font-heading text-gold-500 font-bold uppercase tracking-widest mb-6 border-b border-gold-800/50 pb-2 inline-block" data-id="element-71">
              Navigation
            </h4>
            <ul className="space-y-3" data-id="element-72">
              <li data-id="element-73">
                <a href="#syndication" className="text-parchment-300 hover:text-gold-400 transition-colors" data-id="element-74">
                  Syndication
                </a>
              </li>
              <li data-id="element-75">
                <a href="#solutions" className="text-parchment-300 hover:text-gold-400 transition-colors" data-id="element-76">
                  Solutions
                </a>
              </li>
              <li data-id="element-77">
                <a href="#pricing" className="text-parchment-300 hover:text-gold-400 transition-colors" data-id="element-78">
                  Pricing
                </a>
              </li>
              <li data-id="element-79">
                <a href="#about" className="text-parchment-300 hover:text-gold-400 transition-colors" data-id="element-80">
                  The Inner Circle
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-81">
            <h4 className="font-heading text-gold-500 font-bold uppercase tracking-widest mb-6 border-b border-gold-800/50 pb-2 inline-block" data-id="element-82">
              Headquarters
            </h4>
            <address className="not-italic text-parchment-300 space-y-2" data-id="element-83">
              <p data-id="element-84">Mythicplay Syndicate</p>
              <p data-id="element-85">Limassol, Cyprus</p>
              <p className="pt-4 text-gold-600/80 italic text-sm" data-id="element-86">
                (Visits by arcane portal appointment only)
              </p>
            </address>
          </div>
        </div>

        <div className="border-t border-gold-800/30 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-87">
          <p className="text-parchment-400/60 text-sm" data-id="element-88">
            © 2026 Mythicplay. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm" data-id="element-89">
            <a href="#" className="text-parchment-400/60 hover:text-gold-500 transition-colors" data-id="element-90">
              Privacy Scroll
            </a>
            <a href="#" className="text-parchment-400/60 hover:text-gold-500 transition-colors" data-id="element-91">
              Terms of Covenant
            </a>
          </div>
        </div>
      </div>
    </footer>;
};